export const TEXTS = {
    CONSENT: {
        TITLE: "Don't worry, we won't let you go hungry!",
        SUBTITLE: "",
    },
    SUBTLE_CONSENT_TITLE: "Don't worry, we are still placing your order!",
    TIMELINE: {
        CURRENT_STATE_TEXT: "Place your order now",
        NEXT_STATE_TEXT: "Pay online while food arrives",
        NEXT_STATE_ALTERNATE_TEXT: "or with UPI/Cash on delivery",
        IRCTC_NEXT_STATE_TEXT: "Pay online later",
        IRCTC_NEXT_STATE_ALT_TEXT: "before order preparation",
    },
    PLACE_ORDER: "Place Order Now",
    DONT_PLACE_MY_ORDER: "Don't place my order",
    GO_BACK: "Go Back",
    CTA_PAY_ON_NEXT_SCREEN_AUTOPLACE: "Pay on next screen",
    CTA_PAY_ON_NEXT_SCREEN: "Place Order & then Pay Online",
    CTA_GO_BACK: "Go back to Payments",
    ERROR_TITLE: "Your payment failed",
    CANCEL: "Cancel",
    TICK_SCREEN: {
        MAIN_TEXT: "Order placed!",
        SUB_TEXT: "You can pay while your food arrives",
    },
};

export const A11Y_TEXTS = {
    CTA_PAY_ON_NEXT_SCREEN_AUTOPLACE: "Pay on next screen",
};

export const TIME_INTERVALS = {
    CONSENT: {
        START: 0,
        MAIN_CONTENT_SHOW: 850,
        SHOW_TIMELINE: 3000,
    },
    SUBTLE_AUTOPLACE: {
        API_CALL: 12000,
        SHOW_MAIN_CONTENT: 1800,
        SCALE_UP_DELAY: 1600,
    },
    NAVIGATE_TO_TRACK_SCREEN: 2000,
};

export const COD_PAYMENT_METHOD = {
    groupName: "cod",
    preferred: false,
    fullView: false,
    name: "cod",
    displayName: "Cash",
    paymentCode: "Cash",
    couponApplicable: false,
    rewardApplicable: false,
    enabled: true,
    meta: {
        iconUrl: "PaymentLogos/instruments/4x/Cod",
        promoMsg: "Pay cash at the time of delivery. We recommend you use online payments for contactless delivery",
        popupMessage: "Please confirm your payment via cash on delivery",
        disableMessage: "Cash on delivery is not available.",
    },
    preferredPriority: 0,
    eligibilityCheckRequired: false,
    splitPayEnabled: false,
    showAddMoneyCta: false,
    showLearnMoreHalfCard: false,
};

export const AUTOPAY_ASSETS = {
    MAIN_TEXT_IMG: "payments/SmilingAngel.png",
    TIMELINE_IMG: "payments/Timeline.png",
};
